import React from 'react'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import styles from './Header.module.scss';

import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../module/redux/profile';

import qs from 'query-string';
import axios from 'axios';

import basicProfileImg from '../../icons/user.png';
import { useState } from 'react';

const Header = () => {

  const [isLogin, profile] = useSelector(state => [state.profileReducer.isLogin, state.profileReducer.profile]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const params = qs.parse(location.search);

  const [openMenu, setOpenMenu]  = useState(false);

  const handleLogout = () => {
    axios.get('/api/profile/logout')
      .then((res) => {
        if (res.data.code === 210) {
          dispatch(logout());
          return;
        }

        alert(`오류가 발생하였습니다. CODE:${res.data.code}`);
      })
  }

  return (
    <div id={styles.wrapper_header}>
      <div id={styles.container}>

        <div className={styles.logo} onClick={() => { navigate('/') }}>
          <img src='/icons/logo_white.png' />
          <p>UJAEDAL.com</p>
        </div>

        <div id={styles.nav_profile}>
          {!isLogin &&
            <>
              <Link to='/register' className={styles.nav_item_profile}>회원가입</Link>
              <Link to='/login' className={styles.nav_item_login}>로그인</Link>
            </>
          }
          {isLogin &&
            <>
              <div className={styles.profile}>
                <img src={basicProfileImg} alt='profile' />
                <p className={styles.nickname} onClick={()=>{setOpenMenu(!openMenu)}}>{profile.nickname}<span>{' ▽'}</span></p>
                {openMenu && 
                  <div className={styles.menu}>
                  <div className={styles.logout} onClick={handleLogout}>로그아웃</div>
                  <div className={styles.profile_img}></div>
                  <p className={styles.nickname}>{profile.nickname}<span>님</span></p>
                  <p className={styles.email}>{profile.email}</p>
                </div>
                }
              </div>
              <div className={styles.container_img}>
                <div className={styles.alarm} />
                <div className={styles.mail} />
              </div>
            </>
          }
        </div>

        <div id={styles.nav}>
          <Link
            to='/introduce?rootCategory=introduce'
            className={styles.nav_item}
          ><p>무재달소개</p></Link>
          <div className={styles.del} />
          <Link
            to='/notice?rootCategory=notice'
            className={styles.nav_item}
          ><p>공지사항</p></Link>
          <div className={styles.del} />
          <Link
            to='/download?rootCategory=download'
            className={styles.nav_item}
          ><p>다운로드</p></Link>
          <div className={styles.del} />
          <Link
            to='/community?rootCategory=community&command=list'
            className={styles.nav_item}
          ><p>커뮤니티</p></Link>
          <div className={styles.del} />
          <Link
            to='/service?rootCategory=service'
            className={styles.nav_item}
          ><p>고객센터</p></Link>
        </div>
      </div>
    </div>
  )
}

export default Header